<template>
  <b-form-group
      id="date-input"
      :label="dateName + (isRequired? '*' : '' )"
      label-for="date-input"
      class="bold-label col-12 col-md-6 mb-4"
      :description="$t('Format') + ' : ' + new Date().toLocaleDateString('fr-FR', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'})"
      :invalid-feedback="date.invalidFeedback"
      :state="date.state"
  >
    <vc-date-picker
        ref="date-input"
        v-model="date.value"
        mode="dateTime"
        is24hr
        locale="fr"
        color="orange"
        :popover="{ visibility: 'click' }"
        :minute-increment="5"
        :first-day-of-week="2"
        :modelConfig="modelConfig"
        :min-date="minDate"
    >
      <template v-slot="{ inputValue, inputEvents }">
        <input
            class="border px-2 py-1 rounded date-datepicker"
            :class="{'is-invalid': date.state === false}"
            :value="inputValue"
            v-on="inputEvents"
            :placeholder="$t(dateName)"
            :required="isRequired"
        />
      </template>
    </vc-date-picker>
  </b-form-group>
</template>

<script>
export default {
  name: "DateField",

  props: {
    dateName: {
      type: String,
      default: "Date"
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    minDate: {
      type: Date,
      default: () => null
    },
    modelConfig: {
      type: Object,
      default: () => ({
        type: 'number'
      })
    },
    initValue: {
      type: Date,
      default: null
    }
  },

  data() {
    return {
      date: {
        state: null,
        invalidFeedback: null,
        value: null
      },
    }
  },

  methods: {

    sendInfosToParent() {
      this.$emit(
          'dateInfos',
          this.date.state,
          this.date.invalidFeedback,
          this.date.value,
      )
    },
  },
  watch: {
    'date.value': function () {
      this.sendInfosToParent();
    },
    'initValue': function () {
      this.date.value = this.initValue
    }
  }
}
</script>

<style scoped>
.date-datepicker {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  height: calc(1.5em + 0.75rem + 2px);
  border: 1px solid #ced4da !important;
  border-radius: 0.25rem;
  width: 100%;
}

.date-datepicker.is-invalid {
  border: solid #dc3545 1px !important;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") right 0.75rem center/8px 10px no-repeat, #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e") center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat
}
</style>



// WEBPACK FOOTER //
// src/components/b122/DateField.vue